module.exports = __webpack_public_path__ + "img/lts-wt-en.34500816.png";